module.exports = __webpack_public_path__ + "img/welcome.498d447b.png";